import { APIClient } from "api/api_helper";
import { SUBJECTCHECKOUT_API } from "api/url_helper";
import { GetUserData, CurrentUser } from "common/service/CommonService";

const api = new APIClient();

export const subjectCheckoutService = {
  getSelectAllData: (payload: any) => {
    return api.create(SUBJECTCHECKOUT_API.SUBJECTCHECKOUT + "SelectAll", {
      ...payload,
    });
  },

  getSelectData: (payload: any) => {
    return api.create(SUBJECTCHECKOUT_API.SUBJECTCHECKOUT + "Select", {
      ...payload,
    });
  },

  updateData: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    return api.create(SUBJECTCHECKOUT_API.SUBJECTCHECKOUT + "Update", {
      ...payload,
      updatedby: user.userid,
    });
  },

  deleteData: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    return api.create(SUBJECTCHECKOUT_API.SUBJECTCHECKOUT + "Delete", {
      ...payload,
      updatereason: payload.updatereason,
      updatedby: user.userid,
    });
  },
};
